import { getTimeTillEndOfDayMs } from '@helpers/utils/dates/getTimeTillEndOfDayMs';
import { queryOptions, useQuery } from '@tanstack/react-query';
import {
  fetchPublicListEntities,
  fetchPublicLists,
} from '@terminal/services/watchlist/watchlist';

export const QUERY_KEY_PUBLIC_LISTS = 'QUERY_KEY_PUBLIC_LISTS';
export const QUERY_PUBLIC_LIST_ENTITIES = 'QUERY_PUBLIC_LIST_ENTITIES';

export const createPublicListsQueryOptions = (enabled = true) =>
  queryOptions({
    queryKey: [QUERY_KEY_PUBLIC_LISTS],
    queryFn: fetchPublicLists,
    staleTime: getTimeTillEndOfDayMs(),
    enabled,
  });

export const createPublicListEntitiesQueryOptions = (listId: string) =>
  queryOptions({
    queryKey: [QUERY_PUBLIC_LIST_ENTITIES, listId],
    queryFn: ({ signal }) => fetchPublicListEntities({ signal, listId }),
    staleTime: getTimeTillEndOfDayMs(),
  });

export const usePublicLists = (enabled = true) =>
  useQuery(createPublicListsQueryOptions(enabled));
